module Shared.Domain.SensorType

open Shared.Dto
open Shared.DtoTypes.PhysicalSensor

let fromModel (model: SensorModel) =
    match model with
    | LHT65
    | LSN50v2_S31
    | S31_LS
    | S31_LB -> MapSensorType.Air
    | LSN50v2_Wind
    | SN50v3_LS_Wind
    | SN50v3_LB_Wind -> MapSensorType.WindAverage
    | LSN50v2_Rain_01mm
    | LSN50v2_Rain_02mm
    | SN50v3_LS_Rain_01mm
    | SN50v3_LS_Rain_02mm
    | SN50v3_LB_Rain_01mm
    | SN50v3_LB_Rain_02mm -> MapSensorType.RainFall
    | LSE01
    | SE01_LS
    | SE01_LB -> MapSensorType.Soil
    | LLMS01 -> MapSensorType.LeafletMoisture
    | LSPH01
    | SPH01_LB
    | SPH01_LS -> MapSensorType.PH
    | WSC1L -> MapSensorType.WeatherStation
    | DDS20_LB
    | DDS20_LS
    | PS_LB(WaterDepth _)
    | PS_LS(WaterDepth _) -> MapSensorType.LiquidLevel
    | PS_LB Pressure
    | PS_LS Pressure -> MapSensorType.Pressure
    | RS485_LB_ZFS_02
    | RS485_LS_ZFS_02 -> MapSensorType.SolarRadiation
    | SE0X_LB -> MapSensorType.Soil
    | LDDS75
    | DDS75_LB
    | DDS75_LS -> MapSensorType.Distance
    | WQS_LB
    | WQS_LS -> MapSensorType.WaterQuality